// @flow

import updateOrderField from '../../../Services/updateOrderField';

export default (value: string) => async (dispatch: Function) => {

  dispatch(updateOrderField('notes', value))

}